// @ts-nocheck
/* eslint-disable */
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import DiscountBandAssignmentTable from './DiscountBandAssignmentTable';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToFaresSubSystem } from 'selectors';
import AddDiscountBandAssignment from './addDiscountBandAssignment';
import EditDiscountBandAssignment from './updateDiscountBandAssignment';
import ViewDiscountBandAssignment from './view-DiscountBandAssignment';

const DiscountBandAssignment: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasAddAccess = useTypedSelector(state =>
    hasWriteAccessToFaresSubSystem(state, 'DiscountBandAssignment')
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasAddAccess ? <AddDiscountBandAssignment/> : <NotAuthorized />}
        </Route>
        
        <Route path={`${baseURL}/:id/edit`}>
          {hasAddAccess ? <EditDiscountBandAssignment/> : <NotAuthorized />}
        </Route>
        
        <Route path={`${baseURL}/:id`}>
          <ViewDiscountBandAssignment/>
        </Route>
        
        <Route exact path={`${baseURL}`}>
          <DiscountBandAssignmentTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { DiscountBandAssignment };
